import type { ReactNode } from "react";

interface PageContainerProps {
  eyebrow: string;
  title: string;
  lede: string;
  children: ReactNode;
}

export function PageContainer({ eyebrow, title, lede, children }: PageContainerProps) {
  return (
    <section className="page-container stack-xl">
      <header className="page-header stack-sm">
        <span className="page-eyebrow">{eyebrow}</span>
        <h1 className="page-title">{title}</h1>
        <p className="page-lede">{lede}</p>
      </header>
      {children}
    </section>
  );
}
